import "./base";
import { render, h, options } from "haxt";

options.debug = true;
import { App } from "./App";
import { registerRoutes } from "./routes";
import { Router } from "./@noxtum/router/Router";

(async () => {
	registerRoutes();
	Router.load(window.location.pathname, false);
	let app = document.getElementById("app") as HTMLElement;
	render(<App />, app);
})();
